import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isGardenSoundOn, startGardenSound, stopGardenSound } from "@/lib/gardenSound";

export default function SoundToggle() {
    const [on, setOn] = useState(isGardenSoundOn());

    useEffect(() => {
        const sync = () => setOn(isGardenSoundOn());
        window.addEventListener("garden-sound-changed", sync);
        return () => window.removeEventListener("garden-sound-changed", sync);
    }, []);

    const toggle = () => {
        if (on) stopGardenSound();
        else startGardenSound();
    };

    return (
        <button
            onClick={toggle}
            className="sound-toggle"
            data-testid="sound-toggle-button"
            aria-label={on ? "Mute the garden" : "Hear the garden"}
            title={on ? "Mute the garden" : "Hear the garden"}
        >
            {on ? <Volume2 size={20} /> : <VolumeX size={20} />}
        </button>
    );
}
